window.VWFS = window.VWFS || {};
VWFS.Search = function (searchResult) {
    var resultHtml = "/jcr:content/content/section/section_parsys/searchresult.results.html";
    var resultHtmlAppend = "/jcr:content/content/section/section_parsys/searchresult.resultsappend.html";

    var url;
    var encodedQueryString;
    var awesomplete;

    /**
     * INIT
     */
    this.init = function () {
        document.getElementById("ajax-errorhandling").hidden = true;
        // getting spinner and set on show
        var spinner = document.getElementById("id-modal-spinner");
        spinner.setAttribute('aria-hidden', 'false');
        spinner.querySelector('.c-spinner--full-page').setAttribute('aria-busy', 'true');

        // getting url without Query
        url = window.location.href.split("?")[0].replace(".html", "");
        // getting encoded Query String
        encodedQueryString = encodeURI(window.location.search);

        // Getting Action Url
        var actionUrl = url + resultHtml + encodedQueryString;

        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200 && xhr.response) {
                    spinner.setAttribute('aria-hidden', 'true');
                    spinner.querySelector('.c-spinner--full-page').setAttribute('aria-busy', 'false');
                    searchResult.innerHTML = xhr.response;
                    setupAutoSuggest(searchResult);
                    if (searchResult.querySelector(".js-search-load-more") != null) {
                        searchResult.querySelector(".js-search-load-more").addEventListener('click', loadNextResults)
                    }
                } else {
                    // Show Error Message, in case Response Status was not 200
                    document.getElementById("ajax-errorhandling").hidden = false;
                }
            }
        };
        xhr.ontimeout = function (e) {
            spinner.setAttribute('aria-hidden', 'true');
            spinner.querySelector('.c-spinner--full-page').setAttribute('aria-busy', 'false');
        };
        xhr.open("GET", actionUrl, true);
        xhr.send(null);
    }

    var loadNextResults = function (event) {
        var loadMoreButton = event.currentTarget;
        loadMoreButton.disabled = true;
        var buttonSpinner = loadMoreButton.querySelector(".c-spinner");
        buttonSpinner.hidden = false;
        var buttonIcon = loadMoreButton.querySelector(".c-btn__icon");
        var buttonText = loadMoreButton.querySelector(".c-btn__text");
        buttonIcon.classList.add("u-hide");
        buttonText.classList.add("u-hide");
        var pageSize = loadMoreButton.getAttribute("data-next-page");
        var actionUrl = url + resultHtmlAppend + encodedQueryString + "&page=" + pageSize;
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200 && xhr.response) {
                    loadMoreButton.disabled = false;
                    buttonSpinner.hidden = true;
                    buttonIcon.classList.remove("u-hide");
                    buttonText.classList.remove("u-hide");
                    var response = xhr.response;
                    searchResult.querySelector(".o-list-bare").innerHTML += response;
                    var loadMore = searchResult.querySelector('#loadmore');
                    if (loadMore != null) {
                        loadMore.parentElement.removeChild(loadMore);
                        loadMoreButton.setAttribute("data-next-page", parseInt(pageSize) + 1)
                    } else {
                        loadMoreButton.classList.add('u-hide');
                    }
                } else {
                    // Show Error Message, in case Response Status was not 200
                    document.getElementById("ajax-errorhandling").hidden = false;
                }
            }
        };
        xhr.ontimeout = function () {
            loadMoreButton.disabled = false;
            buttonSpinner.hidden = true;
            buttonIcon.classList.remove("u-hide");
            buttonText.classList.remove("u-hide");
        };
        xhr.open("GET", actionUrl, true);
        xhr.send(null);
    }

    var setupAutoSuggest = function(searchResult) {
        var autoSuggest = searchResult.querySelector('.c-input--autosuggest.js-autosuggest')
        var inputField = autoSuggest.querySelector('input')
        initAutoSuggest(inputField, autoSuggest)

        inputField.addEventListener('keyup', () => {
            initAutoSuggest(inputField, autoSuggest)
            awesomplete.evaluate()
        })
        inputField.addEventListener('focus', () => {
            awesomplete.evaluate()
        })
    }

    var initAutoSuggest = function (inputField, autoSuggest) {
        var inputLength = inputField.value.length
        if (inputLength > 2) {
            loadAutoSuggest(autoSuggest)
        } else {
            loadFrequentlySearched(autoSuggest)
        }
    }

    var loadAutoSuggest = function(autoSuggest) {
        awesomplete = bronson.$$('#' + autoSuggest.id).component('autosuggest').items[0].awesomplete
        if ('autosuggest' in autoSuggest.dataset) {
            awesomplete.list = autoSuggest.dataset.autosuggest.split(',')
            awesomplete.minChars = 3
            awesomplete.options.minChars = 3
            awesomplete.maxItems = 5
        }
    }


    var loadFrequentlySearched = function(autoSuggest) {
        awesomplete = bronson.$$('#' + autoSuggest.id).component('autosuggest').items[0].awesomplete
        if ('frequentlysearched' in autoSuggest.dataset) {
            awesomplete.list = autoSuggest.dataset.frequentlysearched.split(',')
            awesomplete.maxItems = 9
            awesomplete.minChars = 0
            awesomplete.options.minChars = 0
            awesomplete.options.openOnFocus = true
        }
    }

};

/*
 * ON DOCUMENT LOADED
 */

['DOMContentLoaded'].forEach(function (eventName) {
    console.debug("INFO search.js loaded");
    document.addEventListener(eventName, function () {
        document.querySelectorAll(".ajax-search-results").forEach(function (searchResult) {
            new VWFS.Search(searchResult).init();
        })
    });
});
